import React, { Children, cloneElement, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { Wizard } from '../Wizard';

export default function FormWizard({
  error,
  children,
  onSubmit,
  onValueChange,
  onFinalSubmit,
  initialValues = {},
  ...otherProps
}) {
  const [values, setValues] = useState(initialValues);
  const [savedValues, setSavedValues] = useState({});
  const [formRef, setFormRef] = useState(null);

  function handleChangeValues(newValues) {
    const allValues = { ...values, ...newValues };
    setValues(allValues);

    if (onValueChange) {
      onValueChange(allValues);
    }
  }

  function validateForm() {
    const errors = formRef.validate(values);

    if (isEmpty(errors)) {
      return Promise.resolve();
    }

    return Promise.reject();
  }

  function submitForm(resolvedValues) {
    return formRef.submit(null, resolvedValues, savedValues).then(audition => {
      const auditionId = audition;
      setSavedValues(resolvedValues);
      return auditionId;
    });
  }

  function handleSubmit() {
    const resolvedValues = { ...values, isDraft: false };
    return submitForm(resolvedValues).then(result => {
      return onFinalSubmit(result);
    });
  }

  function handleDraftSubmit() {
    const resolvedValues = { ...values, isDraft: true };

    return submitForm(resolvedValues).finally(() => {
      return Promise.reject();
    });
  }

  function handleFormRef(ref) {
    setFormRef(ref);
  }

  const renderChild = child => {
    return cloneElement(child, {
      onSubmit,
      error,
      initialValues: values,
      handleRef: handleFormRef,
      showFooter: false,
      onChangeValues: handleChangeValues,
    });
  };

  return (
    <Wizard
      finalButtonLabel="Save"
      onSubmit={handleSubmit}
      onPageNavigation={validateForm}
      onPreviousPage={handleDraftSubmit}
      {...otherProps}
    >
      {Children.map(children, renderChild)}
    </Wizard>
  );
}
